// extracted by css-extract-rspack-plugin
export default {"header":"src-modules-auth-templates-AuthPageTemplate-AuthTemplateHeader-AuthTemplateHeader-module__header-D0SFCH","dateTime":"src-modules-auth-templates-AuthPageTemplate-AuthTemplateHeader-AuthTemplateHeader-module__dateTime-ekQ4QU","logo":"src-modules-auth-templates-AuthPageTemplate-AuthTemplateHeader-AuthTemplateHeader-module__logo-LerrQy","links":"src-modules-auth-templates-AuthPageTemplate-AuthTemplateHeader-AuthTemplateHeader-module__links-X4HStO"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"header\":\"src-modules-auth-templates-AuthPageTemplate-AuthTemplateHeader-AuthTemplateHeader-module__header-D0SFCH\",\"dateTime\":\"src-modules-auth-templates-AuthPageTemplate-AuthTemplateHeader-AuthTemplateHeader-module__dateTime-ekQ4QU\",\"logo\":\"src-modules-auth-templates-AuthPageTemplate-AuthTemplateHeader-AuthTemplateHeader-module__logo-LerrQy\",\"links\":\"src-modules-auth-templates-AuthPageTemplate-AuthTemplateHeader-AuthTemplateHeader-module__links-X4HStO\"}";
        // 1793873552574
        var cssReload = require("../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  